// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"DashboardLayout_dashboardLayout__a-LBM","mainContent":"DashboardLayout_mainContent__J+G-Y","content":"DashboardLayout_content__Iq70m"};